export interface CostItem {
  term: number;
  rate: number;
  text: string;
}

export interface CostInfo {
  monthly: {
    quantity: number;
    text: string | null;
    items: CostItem[];
  };
  onceOff: {
    quantity: number;
    text: string | null;
    items: CostItem[];
  };
  name: string;
}

export interface Option {
  title: string;
  label: string;
  cost: CostInfo;
  value: string;
  retention?: string;
  customerBenefitProduct?: string;
  information?: string;
  disclaimer?: string;
  description?: string;
  discountDurationInMonths?: number;
  discountTariff?: number;
}

export const transformCost = (cost: CostInfo) => {
  if (cost.monthly.quantity > 0) {
    const pricesArray = cost.monthly.items.map(({ text }) =>
      text.replace(/&euro;/gi, '€'),
    );
    return pricesArray.join(' dan ');
  }
  return cost.onceOff.items[0].text.replace(/&euro;/gi, '€');
};
